export default __webpack_public_path__ + "static/media/shipped_gray.30754b2b.svg";